

export default {
  activeTime: '活跃时间',
  addTime: '加入时间',
  join: '加入',
  bit: '位',
  cancel: '取消',
  connectError: '连接失败',
  connectOK: '连接成功',
  copy: '复制',
  copyError: '复制失败',
  copyOK: '复制成功',
  delete: '删除',
  deleteError: '删除失败',
  deleteOK: '删除成功',
  uninstallText: '卸载命令',
  uninstallURL: 'https://github.com/openp2p-cn/openp2p/blob/master/USAGE-ZH.md#%E5%8D%B8%E8%BD%BD',
  device: '设备',
  network: '网络',
  deviceName: '设备名字',
  edit: '编辑',
  editing: '正在编辑',
  email: '邮箱',
  install: '安装',
  lanip: '内网IP',
  latestVer: '最新版本',
  login: '登录',
  loginError: '登录失败',
  logout: '退出登录',
  offline: '离线',
  ok: '确定',
  online: '在线',
  optional: '(可选)',
  os: '操作系统',
  p2papp: 'P2P应用',
  phone: '手机',
  profile: '我',
  reboot: '重启',
  refresh: '刷新',
  regTime: '注册时间',
  requesting: '正在请求数据...',
  requestTimeout: '请求超时，请稍后重试',
  save: '保存',
  saveError: '保存失败',
  saveOK: '保存成功',
  search: '搜索',
  sharebw: '共享带宽',
  tokenExpired: '登录凭证无效，请重新登录',
  update: '升级',
  version: '软件版本',
  wanip: '公网IPv4',
  total1: '成功为用户建立连接次数:',
  send: '发送验证码至邮箱',
  sendVerificationCodeOK: '发送验证码成功，请前往邮箱查看',
  sendVerificationCodeError: '发送验证码失败',
  emailInvalidError: '邮箱未注册',
  confirm: '确认',
  invalidCharacter: '非法字符',
  pro: {
    errReq: '获取个人信息失败',
    info: '的个人信息',

  },
  inst: {
    linuxDesc: '根据自己的环境，选择下面其中一种安装方法：',
    linuxDescSh: '1. 在shell执行下面命令，需要root权限',
    linuxDescWrt: '2. 当没有sudo、curl或bash时使用以下命令（OpenWRT）',
    linuxDescDocker: '3. 使用Docker在容器里跑(注意这里使用latest版本可能因为本地缓存导致拿不到最新版本。你需要手动执行docker pull openp2pcn/openp2p-client:latest或者把latest改成最新版本号',
    win10warn: '由于这是免费项目，没有购买微软证书为程序签名，Windows默认会阻止运行，选择“仍要运行”即可。',
    windowsDesc: '下载Windows客户端，一键安装',
    download: '下载',
    androidDesc: '使用手机浏览器打开，点击下载并安装',

  },
  apps: {
    diffVer: '版本不一致，可能无法建立P2P应用，建议都升级到最新版本',
    direct: '直连',
    directIPv4: 'IPv4直连',
    directIPv6: 'IPv6直连',
    directIntranet: '内网直连',
    dstHost: '远程服务地址',
    dstPort: '远程服务端口',
    whitelist: '访问白名单',
    errNotChosen: '请选择远程设备',
    errPortRange: '端口范围0-65535',
    hasBeen: '已被【',
    link: '链路',
    localNode: '本地设备',
    localPort: '本地监听端口',
    name: '应用名字',
    new: '新建APP',
    noApp: '该设备没有创建应用',
    occupy: '】占用',
    pleaseChoose: '请选择',
    port: '端口',
    privateNet: '私有网络',
    protocol: '协议',
    publicNet: '公有网络',
    relay: '中转',
    relayNode: '中转节点',
    remoteNode: '远程设备',
    remoteService: '远程服务',
    title: '的全部P2P应用',
    tooLong: '应用名字长度不大于32字符',
    connecting: '正在连接...',
    disabled: '未启用',
    connectTime: '连接时间',
    whitelistTips1: '例子1：127.0.0.1,192.168.1.0/24,10.1.1.30-10.1.1.50',
    whitelistTips2: '例子2：127.0.0.1 （只允许本机访问）',
    whitelistTips3: '例子3：192.168.1.0/24',
    whitelistTips4: '例子4：10.1.1.30-10.1.1.50',
    androidListenPortTooLow: "Android设备监听端口小于10000有可能失败"

  },
  nodes: {
    atleast2: '您至少需要在两台设备安装OpenP2P，然后创建P2P应用，就可以直接访问',
    nameTooShort: '设备名字不能少于8个字符',
    nonode: '没有安装客户端',
    operationError: '操作失败',
    operationOK: '操作成功',
    pushUpgradeError: '推送升级失败',
    pushUpgradeOK: '推送升级成功',
    androidManualUpgrade: 'Android客户端需要手动重新安装最新版本',
    natType: 'NAT类型',
  },
  reg: {
    newUser: '注册新用户',
    forgotPwd: '忘记密码?',
    forgotPwdDetail: '加QQ群16947733联系群主',
    noAuth: '(无需任何手机、邮箱、微信公众号等认证)',
    noUser: '还没有账户？ ',
    password: '密码',
    passwordConfirm: '确认密码',
    pwdDiff: '两次输入密码不一致，请重新输入',
    register: '注册',
    registerError: '注册失败',
    registerOK: '注册成功',
    resetPwdError: '重置失败',
    resetPwdOK: '重置成功',
    title: '新用户注册',
    tooShort: '用户名和密码长度不能少于8个字符',
    username: '用户名',
    emailTips: '用来找回密码',
    resetPwd: '重置密码',
    verifyCode: '验证码',
    userBeenUsed: '用户名已被注册',
    emailOrPhoneBeenUsed: '邮箱或手机已被注册',
    verificationCodeError: '验证码错误',
    agreeTerms: '阅读并同意',
    userAgreement: '用户协议',
    agreeTermsFirst: '请先勾选同意用户协议',
    agreementDetail: '本项目开源供大家学习和免费使用，禁止用于非法用途，任何不当使用本项目或意外造成的损失，本项目及相关人员不会承担任何责任。',
  },
  sdwan: {
    tabName: '虚拟网络',
    member: '网络成员',
    virtualIP: '虚拟IP',
    gateway: '网关',
    resource: '网络资源*',
    resourceTips: '默认为空。设置网络资源可以使其它成员访问整个局域网。<br>例子:192.168.3.0/24<br>（目前仅支持linux系统）',
    control: '操作',
    myNetwork: '我的网络',
    tooManyMembers: '成员数不能超过5个',
    versionLow: '所选设备版本太低，请升级至最新版本',
    connectStatus: '连接状态',
    detail: '详细',
    fullmeshMode: 'P2P模式',
    centralMode: '中心模式',
    centralNode: '中心节点',
    specifiedRelayNode: '指定中转节点',
    notSpecified: '不指定',
    forceRelay: '强制中转',
    chooseSDWANMember: '请选择网络成员',
    modeTips: 'P2P模式：会fullmesh连接，即每个节点都会和其它所有节点连接，只适合成员数少的网络<br>中心模式：每个成员只会和中心节点连接，成员之间不会互联；适合成员数多,且有稳定在线容易建立P2P连接的成员（比如云主机）',
    centralTips: '请选择稳定在线且容易建立P2P连接的成员（比如云主机）,如果拥有公网IP请务必放行config.json里的TCPPort端口',
    centralModeNotSpecifiedNode: '中心模式必须指定一个中心节点',
    diffVer: '各成员版本不一致，可能无法通信，建议都升级到最新版本',
  }

}
